module.exports = __webpack_public_path__ + "img/icon_3_3.f51ae242.png";